import { Injectable } from "@angular/core";
import {
    ActivatedRouteSnapshot,
    Router,
    RouterStateSnapshot,
} from "@angular/router";
import { Apollo } from "apollo-angular";
import { UserService } from "../services/user/user.service";

@Injectable({
  providedIn: "root",
})
export class LoginGuard {
  constructor(
    private userService: UserService,
    private router: Router,
    private apollo: Apollo
  ) {}

  canActivate = async (route:ActivatedRouteSnapshot, state:RouterStateSnapshot): Promise<boolean> => {
    const token = await this.userService.ensureValidSession();

    if (!token) {
      this.router.navigate(['/login']);
      return false;
    }

    return true;
  }
  

    
  
}
